import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { calcRem, colors, fonts, metrics } from '../../../__styling'
import { WebLink } from '@news-mono/web-common'

export const StyledWebLinkButton = styled(WebLink)({
    background: tokens.thenightly.colors.palette.uplate.default,
    margin: calcRem(metrics.thenightly.margins.xxxl, 0, 0, 0),
    padding: calcRem(
        metrics.thenightly.margins.sm2l,
        metrics.thenightly.margins.m2l,
    ),
    justifyContent: 'center',
    borderRadius: calcRem(8),
    border: 0,
    color: colors.white,
    display: 'inline',

    '&:active, &:hover, &:focus': {
        background: tokens.thenightly.colors.palette.uplate.hover,
        cursor: 'pointer',
    },

    textDecorationLine: 'none',

    // FONT STYLING
    fontFamily: fonts.thenightly.navigation,
    fontSize: metrics.thenightly.baseFontSize,
    fontWeight: 600,
    lineHeight: calcRem(24),
    textTransform: 'uppercase',
    width: '100%',
    textAlign: 'center',
})
